<template>
  <div class="container-fluid">
    <div class="vld-parent row pb-4 pr-0" :class="deployemntBgClass" :id="$id('calendar')" ref='calendarContainer'>

      <make-booking
        ref="makeBooking"
        :location="location"
        :initial-cart="initialCart"
        :saleFrom="saleFrom"
        :locationDiscount="locationDiscount"
        :brand="brand"
        :location-child-pricing="locationChildPricing"
        :adult-pricing-not-player-pricing="adultPricingNotPlayerPricing"
        :customer-request-marketing-permission="customerRequestMarketingPermission"
        :payment-provider="paymentProvider"
        :booking-label-adults="bookingLabelAdults"
        :booking-label-adults-selection="bookingLabelAdultsSelection"
        :booking-child-caveat="bookingChildCaveat"/>

      <div
        class="col px-0 calendarWeekGrid"
        :id="$id('mainCal')">
        <div :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
          <div class="bgDarker">
            <div class="row pt-4">
              <div class="col text-center">
                <h2 class="font-weight-bold calendarWeekGrid_Header_Title">
                  {{ virtualGames.length }} Available Virtual Games for {{ $deploymentIs('breakescape') ? location.name.toUpperCase() : location.name }}
                </h2>
              </div>
            </div>

            <template v-for="virtualGame in virtualGames">
              <div class="row pt-4">
                <div class="col">
                  <img :src="'/img/mp/mp-ls-' + virtualGame.nickname + '.jpg'" class="img-fluid" :alt="virtualGame.name + ' poster'">
                </div>
                <div class="col">
                  <h4 class="font-weight-bold">{{ virtualGame.name }}</h4>
                  <p>{{ trimBlurbs(virtualGame.blurbs, 120) }}</p>
                </div>
                <div class="col">
                  <template v-if="virtualGame.totalAvailableGames == 0">
                    <button
                      :class="'button-' + $deploymentCurrent + ' btn-red disabled'">
                      Not Enough Stock<br>
                      Please Contact Us
                    </button>
                  </template>
                  <template v-else>
                    <button
                      :class="'button-' + $deploymentCurrent + (virtualGame.totalAvailableGames == 0 ? ' btn-red disabled' : '')"
                      @click.prevent="addVirtualGameToCart(virtualGame)">
                      Add To Cart<br>
                      {{ virtualGame.price | money }}
                    </button>
                  </template>
                </div>
              </div>
            </template>

            <!-- THE CART -->
            <booking-calendar-cart-summary
              v-model="cart"
              :location="location"></booking-calendar-cart-summary>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialCart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    currentRoomId: {
      type: Number,
      default: null,
    },
    initialDate: {
      type: String,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'R',
    },
    locationDiscount: {
      type: Object,
    },
    initialRoomSlots: {
      type: [Object, Array],
      // required: true,
    },
    initialRoomsAvailable: {
      type: [Object, Array],
      // required: true,
    },
    brand: {
      type: String,
    },
    maxPerRow: {
      type: Number,
      default: 5,
    },
    locationChildPricing: {
      type: Boolean,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    paymentProvider: {
      type: String,
      default: 'Testing',
    },
    axeThrowing: {
      type: Boolean,
      default: false,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    showPlayers: {
      type: Boolean,
      default: false,
    },
    bookingLabelAdults: {
      type: String,
      default: 'Adults',
    },
    bookingLabelAdultsSelection: {
      type: String,
      default: 'Select number of adults',
    },
    bookingChildCaveat: {
      type: String,
      default: 'Minimum of 2 adult tickets per game, regardless of age. A child is defined as 15 or younger.',
    },
  },

  data() {
    return {
      roomSlots: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialRoomSlots))),
      roomsAvailable: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialRoomsAvailable))),

      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),
    };
  },

  computed: {
    virtualGames() {
      return this.location.virtual_games;
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    promoDate() {
      if (this.locationDiscount) {
        return moment(this.locationDiscount.date).format('YYYY-MM-DD');
      } else {
        return "N/A";
      }
    },

    roomSlotIdsInCart() {
      let roomSlotIds = [];

      if (this.cart) {
        this.cart.cart_items.forEach(cartItem => {
          if (cartItem.cartable_type == 'App\\Models\\RoomSlot') {
            roomSlotIds.push(cartItem.cartable_id);
          }
        });
      }

      return roomSlotIds;
    },

    deployemntBgClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'bg-cryptology-blue';
        case 'makeyourescape':
          return '';
        case 'coalville':
          return 'bg-lightest-gray';
        case 'escapestaging':
          return 'bg-escapestaging';
        case 'breakescape':
          return 'bg-breakescapebtn text-black';
        case 'levelup':
          return 'bg-levelup text-black';
        case 'taketheexit':
        case 'paralysis':
        case 'horrorescape':
        case 'escapegoat':
        case 'missionclassified':
        case 'rushden':
        case 'topescaperooms':
        case 'panicroomharlow':
        case 'escaporium':
        case 'axefactor':
        case 'escapetime':
        case 'operationescape':
        case 'oo7escaperooms':
        case 'theescapelounge':
        case 'lakesescapes':
          return 'bg-darkest-gray text-white';
        case 'cypherquest':
          return 'bg-cypherquest text-white';
        case 'kanyu':
        case 'beyondbreakout':
        case 'crypticescape':
        case 'escapereading':
          return 'bg-white text-black';
        case 'wisbech':
          return 'bg-wisbech text-white';
        case 'makeyourescape':
          return '';
        case 'the-real-escape':
          return 'bg-the-real-escape-bg text-white';
        case 'escapable':
          return 'bg-calendar-lighten-opacity text-white';
        case 'bridlington':
          return 'bg-bridlington-lighter text-white';
        case 'mansionofmystery':
          return 'bg-mansionofmysterypurple text-white';
        default:
          return 'bg-white text-black';
      }
    },
  },

  methods: {
    /* ===============
     * mainCal methods
     */

    trimBlurbs(blurbs, displayLimit) {
      var text = blurbs.join();
      if (text.length > displayLimit) {
        return text.slice(0, displayLimit) + '…';
      } else {
        return text;
      }
    },

    refetchRoomSlots() {
      this.fetchRoomSlots(this.date);
    },

    fetchRoomSlots(newDate) {
      let roomSlotsRequest = {
        for_rooms_for_week: 1,
        room_ids: this.location.rooms.map(room => room.id),
        date: newDate.toISOString(true),
      };

      let roomsAvailableRequest = {
        ...roomSlotsRequest,
        availability_only: 1,
      };

      this.loading(true, this.$refs.calendarContainer);

      Promise.all([
        axios.get(this.route('api.room-slots.index'), {params: roomSlotsRequest}),
        axios.get(this.route('api.room-slots.index'), {params: roomsAvailableRequest})
      ])
        .then(results => {
          const roomSlotsResponse = results[0];
          const roomsAvailableResponse = results[1];

          if (roomSlotsResponse.status == 200 && roomsAvailableResponse.status == 200) {
            this.roomSlots = roomSlotsResponse.data;
            this.roomsAvailable = roomsAvailableResponse.data;
            this.date = newDate;
          } else {
            flash('Error fetching data.', 'danger');
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.data);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.status);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.statusText);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.data);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.status);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error fetching room slots', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('fetchRoomSlots:401', error.response.data);
              window.location.reload();
            }
            console.log('fetchRoomSlots: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('fetchRoomSlots: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('fetchRoomSlots: Error', error.message);
          }

          this.loading(false);
        });
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      url.searchParams.set(param, value);
      let state = {[param]: value};
      history.pushState(state, '', url);
    },

    /* ===============
     * timeslotCal methods
     */

    addVirtualGameToCart(virtualGame) {
      console.log('addVirtualGameToCart', virtualGame);

      this.$refs.makeBooking.startVirtualBooking(virtualGame);
    },

    /* ===============
     * Echo methods
     */
    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
    },

    cartSavedEvent(event) {
      console.log('cartSavedEvent(event)', event);
      this.cart = event.cart;
    },

    locationRoomRoute(room_id, date) {
      let room = this.location.rooms.find(room => room.id == room_id);

      return this.route(this.location.locationRoomRoute, {location: this.location, room: room, dt: date});
    },

    /*
     * END Echo methods
     * =============== */

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.echoInitCart();
    });

  },

  beforeDestroy() {
    this.echoDeInitCart();
  },
}
</script>
